function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.926,95.025L72.317,68.417c6.357-7.262,10.224-16.758,10.224-27.146C82.541,18.514,64.027,0,41.271,0 C18.515,0,0,18.514,0,41.271c0,22.757,18.515,41.271,41.271,41.271c9.853,0,18.907-3.476,26.012-9.26l26.692,26.693 c0.684,0.684,1.58,1.024,2.476,1.024s1.791-0.341,2.475-1.024C100.293,98.608,100.293,96.393,98.926,95.025 M7,41.271 C7,22.374,22.374,7,41.271,7c18.896,0,34.27,15.374,34.27,34.271c0,9.558-3.937,18.211-10.27,24.433 c-0.115,0.089-0.234,0.171-0.339,0.276c-0.066,0.065-0.113,0.142-0.173,0.211c-6.14,5.789-14.403,9.351-23.488,9.351 C22.374,75.542,7,60.168,7,41.271"
});

var SvgCerca = function SvgCerca(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "-0.931 -0.935 101 102",
    enableBackground: "new -0.931 -0.935 101 102",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCerca, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cerca.7c7ffad4.svg";
export { ForwardRef as ReactComponent };